export const columnLabels = {
    id: "ID",
    name: "Navn",
    created: "Opprettet",
    published: "Publisert",
    taxYears: "Skatteår",
    county: "Fylke",
    municipalityNumber: "Kommunenummer",
    place: "Sted",
    type: "Type",
    zip: "Postnummer"
};

export const editableColumns = ["name", "place", "published"];

const columnSortMap = {
    id: 0,
    number: 0,
    zip: 0,
    name: 1,
    place: 1,
    county: 2,
    municipalityNumber: 2,
    type: 3,
    taxYears: 98,
    created: 99,
    published: 100
}

export const sortColumns = (a, b) => {
    return columnSortMap[a] - columnSortMap[b];
};
